module.exports = __webpack_public_path__ + "static/media/tut2.b684c568.png";